import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { Template } from '../../models/template';
import { TemplateType } from '../../models/templatetype';
import { NostosService } from '../../services/nostos.service';

@Component({
  selector: 'app-template-dialog',
  templateUrl: './template-dialog.component.html',
  styleUrl: './template-dialog.component.css',
  imports: [
    MatDialogModule,
    MatCheckboxModule,
    FormsModule,
    MatListModule,
    CommonModule,
    MatTabsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatSelectModule
  ]
})
export class TemplateDialogComponent implements OnInit {

  template: Template;
  templateTypes: TemplateType[] = [];
  selectedTemplateType!: TemplateType;
  errorMsg: string = "";
  sample: string = "";
  evalMsg: string = "";

  get isMatched(): boolean {
    try {
      const regex = new RegExp(this.template.test);
      return regex.test(this.sample);
    } catch {
      return false;
    }
  }

  get extractedValue(): string {
    try {
      if (this.sample.trim().length == 0) return "";
      return this.evalExtractor(this.template.eval, this.sample);
    } catch {
      return "";
    }
  }

  constructor(
    private nostosService: NostosService,
    public dialogRef: MatDialogRef<TemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { template: Template }
  ) {

    this.template = data.template;

  }

  ngOnInit(): void {

    this.nostosService.getTemplateTypes().subscribe(x => {
      this.templateTypes = x;
      var theType = x.find(t => t.templateTypeId == this.template.templateTypeId);
      this.selectedTemplateType = (theType !== undefined ? theType : x[0]);
    });

  }

  onCancel(): void {
    this.dialogRef.close(null); // dismiss dialog
  }

  onConfirm(): void {

    this.template.templateTypeId = this.selectedTemplateType.templateTypeId;
    this.dialogRef.close(this.template);

  }

  isValidRegex(pattern: string): string {

    try {
      new RegExp(pattern);
      return "";
    } catch (e) {
      return String(e);
    }

  }

  isValidJS(code: string): string {

    try {
      new Function(`return (${code});`);
      return "";
    } catch (e) {
      return String(e);
    }

  }

  evalExtractor(extractorFn: string, entry: string): string {

    this.evalMsg = "";
    try {
      const fn = new Function('entry', `return (${extractorFn});`);
      const result = fn(entry);
      return result;
    } catch (err) {
      this.evalMsg = String(err);
      return '';
    }

  }

  isFormValid(): boolean {

    this.errorMsg = "";

    if (this.template.name === null || this.template.name === undefined || this.template.name === '') {
      this.errorMsg = "A Name is required.";
      return false;
    }
    if (this.template.test === null || this.template.test === undefined || this.template.test === '') {
      this.errorMsg = "A Test is required";
      return false;
    }
    if ((this.selectedTemplateType.name == 'Extractor') && (this.template.eval === null || this.template.eval === undefined || this.template.eval === '')) {
      this.errorMsg = "A JavaScript expression is required";
      return false;
    }

    var t = this.isValidRegex(this.template.test);
    if (t.length > 0) {
      this.errorMsg = `Invalid Test regular expression: [${t}]`;
      return false;
    }

    if ((this.selectedTemplateType.name == 'Extractor')) {
      var e = this.isValidJS(this.template.eval);
      if (e.length > 0) {
        this.errorMsg = `Invalid Extractor JavaScript expression: [${e}]`;
        return false;
      }
    }

    return true;

  }

}
